import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { buildUseStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import fr from 'facet-rest';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import BaseOverride from 'Views/Page/Content/Templates/BaseOverride';
import { useHistory } from 'react-router-dom';
import { hasRelationship } from 'Helpers/Affordances';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import Content from './Content';

const useStyles = buildUseStyles('AcatTransferFundsTemplate', () => ({
  root: {},
}));

const AcatTransferFundsTemplate = ({
  className,
  resource,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const history = useHistory();
  const { loadPageContentLink } = usePageContentContext();
  const [isPartialTransfer, setIsPartialTransfer] = useState(false);

  const onClose = async () => {
    if (hasRelationship(resource, fr.relationships.redirectOnClose.name)) {
      await loadPageContentLink(resource.relationship(fr.relationships.redirectOnClose.name).link('related'));
    } else {
      history.push('/');
    }
  };

  const onChange = (attr, value) => {
    if (attr !== 'transferType') {
      return;
    }

    if (value === 'partial-transfer') {
      setIsPartialTransfer(true);
      return;
    }

    setIsPartialTransfer(false);
  };

  return (
    <WizardStepWrapperTemplate
      className={classNames(className, classes.root)}
      layout={Content}
      resource={resource}
      primaryActionLabel={resource.attr('primaryActionText')}
      metaOverrideSet={BaseOverride}
      onClose={onClose}
      hideErrors
      submitConfirmation
      submitConfirmationTitle={'Initiate Full Transfer'}
      submitConfirmationMessage={resource.attr('subtitle')}
      submitConfirmationButtonLabel={'Submit'}
      disableNextButton={isPartialTransfer}
      LayoutProps={{ onChange, isPartialTransfer }}
    />
  );
};

AcatTransferFundsTemplate.defaultProps = {
  className: '',
};

AcatTransferFundsTemplate.propTypes = {
  className: PropTypes.string,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default AcatTransferFundsTemplate;
